var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Idea-details_join_team-9",
    transform: "translate(-1123.000000, -603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(1123.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Report"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(5.600000, 5.600000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 25.6,
    height: 25.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(5.600000, 2.400000)",
    stroke: "#6D45FF",
    strokeLinecap: "round",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 0.4,
    x2: 0.4,
    y2: 20.4,
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.876367188,10.4 C3.07604167,11.4228516 5.2108724,11.4228516 7.28085938,10.4 C9.08936336,9.50635615 11.1526783,9.3934701 13.4708043,10.0613418 C13.8953635,10.1836639 14.3386968,9.93864946 14.4610162,9.51408946 C14.4817593,9.44209177 14.4922852,9.36753699 14.4922852,9.29261072 L14.4922852,1.40482436 C14.4923158,1.06007089 14.2714645,0.754089985 13.9442564,0.645509199 C11.4649632,-0.177219726 9.24340773,-0.112311334 7.27958984,0.840234375 C5.17216797,1.8624349 3.03776042,1.8624349 0.876367188,0.840234375",
    id: "Path-4"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#7834FF",
    strokeWidth: 0.8,
    cx: 17.6,
    cy: 17.6,
    r: 17.2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.3757d07967a1f866a48da70d835ab002.svg";
export { ForwardRef as ReactComponent };